export const INTEROPERABILITY = 'interoperability'
export const INFRASTRUCTURE = 'infrastructure-build'
export const EXISTING_PARTNERSHIP = 'existing-partnerships'

export const BASE_URL = process.env.REACT_APP_BASE_URL + '/api'
export const DEFAULT_PARAM = 'populate=deep'
export const BASE_APP_URL = process.env.REACT_APP_BASE_URL

export const mediaParamList = {
  'press-releases': 'press-updated',
  'media-coverage': 'media-coverage',
  'events-and-awards': 'eventsand-award',
  whitepapers: 'white-paper',
  'safe-banking': 'safebanking',
  newsletter: 'newsletters',
  'digital-media-kit': 'digital-media',
}

export const CAREER = 'career'

export const statisticsParamsList = {
  'product-statistics': 'statisticsapis',
  uptime: 'uptimes',
  'bd-td': 'bd-td',
}

export const partnershipsParamList = {
  'existing-partnerships': 'our-parnter',
  'infrastructure-build': 'upcomingpartner',
}

// export const phoneRegex =
//   /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/

export const phoneRegex = /^[0-9]*$/

export const emailRegex =
  /^(?!\s)(?!.*\.\.)(?!.*\.$)[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?!\s)$/

export const defaultCountries = {
  en: 'US', // Default to United States for English
  fr: 'FR', // Default to France for French
  es: 'SP', // Default to France for Spanish
  ar: 'EG', // Default to France for Arabic
}

export const SEOPageNames = {
  '/': 'Homepage',
  '/about-us/who-we-are': 'About NPCI International',
  '/about-us/who-we-are/vision-and-mission': 'Vision and Mission',
  '/about-us/who-we-are/board-of-directors': 'Board of Directors',
  '/about-us/who-we-are/management-team': 'Management Team',
  '/about-us/who-we-are/global-presence': 'Our Presence',
  '/about-us/our-partners/existing-partnerships': 'Interoperability',
  '/about-us/our-partners/infrastructure-build': 'Infrastructure Build',
  '/about-us/risk-and-governance/corporate-governance': 'Corporate Governance',
  '/about-us/risk-and-governance/risk-management': 'Risk Management',
  '/about-us/who-we-are/csr': 'CSR',
  '/how-it-works/interoperability/upi': 'Interoperability UPI',
  '/how-it-works/interoperability/rupay': 'Interoperability RuPay',
  '/how-it-works/interoperability/remittances': 'Interoperability Remittances',
  '/how-it-works/infrastructure-build/upi': 'Infrastructure UPI',
  '/how-it-works/infrastructure-build/rupay': 'Infrastructure RuPay',
  '/get-in-touch/career': 'Careers',
  '/get-in-touch/contact-us': 'Contact Us',
  '/media-and-coverage/press-releases': 'Press releases',
  '/media-and-coverage/media-coverage': 'Media Coverage',
  '/media-and-coverage/knowledge-center/whitepapers': 'Knowledge Centre',
  '/media-and-coverage/knowledge-center/newsletter': 'Knowledge Centre',
  '/media-and-coverage/knowledge-center/safe-banking': 'Knowledge Centre',
  '/media-and-coverage/events-and-awards': 'Events and Awards',
  '/media-and-coverage/digital-media-kit': 'Digital Media Kit',
  '/how-it-works/frequently-asked-questions/upi': 'UPI',
  '/how-it-works/frequently-asked-questions/rupay': 'RuPay',
  '/how-it-works/frequently-asked-questions/remittances': 'Remittances',
  '/how-it-works/frequently-asked-questions/upipaynow': 'UPI PayNow',
  '/statistics-and-milestones/statistics/product-statistics': 'Statistics',
  // '': 'Fraud Awareness',
}

export const ContactUsConstants = {
  email: 'email',
  call: 'call_us',
}

export const languageCode = {
  ENGLISH: 'en',
  SPANISH: 'es',
  FRENCH: 'fr',
  ARABIC: 'ar',
}
